import React from 'react';
import {
  CalendarClock,
  LogOut,
  MessageSquareMore,
  Table,
  UserRound,
  UsersRound,
  Utensils,
} from 'lucide-react';
import {DashboardView} from '../dashboard/types';

interface SidebarProps {
  activeView: DashboardView;
  canManageReservations: boolean;
  canManageUsers: boolean;
  onChangeView: (view: DashboardView) => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  activeView,
  canManageReservations,
  canManageUsers,
  onChangeView,
  onLogout,
}) => {
  return (
    <aside className='side-rail'>
      {canManageReservations && (
        <button
          className={`rail-btn ${activeView === 'reservations' ? 'active' : ''}`}
          onClick={() => onChangeView('reservations')}
          aria-label='Reservations'>
          <CalendarClock
            size={18}
            className='rail-icon'
          />
          <span>Reservations</span>
        </button>
      )}
      {canManageUsers && (
        <button
          className={`rail-btn ${activeView === 'users' ? 'active' : ''}`}
          onClick={() => onChangeView('users')}
          aria-label='Users'>
          <UsersRound
            size={18}
            className='rail-icon'
          />
          <span>Users</span>
        </button>
      )}
      {canManageReservations && (
        <button
          className={`rail-btn ${activeView === 'messages' ? 'active' : ''}`}
          onClick={() => onChangeView('messages')}
          aria-label='Messages'>
          <MessageSquareMore
            size={18}
            className='rail-icon'
          />
          <span>Messages</span>
        </button>
      )}
      {canManageReservations && (
        <button
          className={`rail-btn ${activeView === 'tables' ? 'active' : ''}`}
          onClick={() => onChangeView('tables')}
          aria-label='Tables'>
          <Utensils
            size={18}
            className='rail-icon'
          />
          <span>Tables</span>
        </button>
      )}
      <button
        className={`rail-btn ${activeView === 'profile' ? 'active' : ''}`}
        onClick={() => onChangeView('profile')}
        aria-label='Profile'>
        <UserRound
          size={18}
          className='rail-icon'
        />
        <span>Profile</span>
      </button>
      <button
        className='rail-btn rail-end'
        onClick={onLogout}
        aria-label='Sign Out'>
        <LogOut
          size={18}
          className='rail-icon'
        />
        <span>Sign Out</span>
      </button>
    </aside>
  );
};

export default Sidebar;
